import styles from './FlintPager.module.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons";
import {useEffect, useState} from "react";
import {Hint} from "@progress/kendo-react-labels";

export default function FlintPager({defaultPage = 1, pageSize = 50, totalItems = 0, onPageChange}: PagerProps) {
    const totalPages: number = Math.ceil(totalItems / pageSize);
    const [currentPage, setCurrentPage] = useState(defaultPage);
    const startItem = (currentPage - 1) * pageSize + 1;
    const endItem = Math.min(startItem + pageSize - 1, totalItems);
    const goToPage = (e: React.MouseEvent, page: number) => {
        e.preventDefault();
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            onPageChange && onPageChange(page);
        }
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            if (currentPage <= 4) {
                pageNumbers.push(1, 2, 3, 4, 5, '...', totalPages);
            } else if (currentPage > totalPages - 4) {
                pageNumbers.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                pageNumbers.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return pageNumbers;
    };

    return (
        <div className={"d-flex flex-wrap align-items-center gap-2"}>
            <div className={"font-size-md text-nowrap"}>{startItem} - {endItem} of {totalItems} items</div>
            {totalItems <= pageSize ? null :
                <nav aria-label="grid pager" className="grid-pager">
                    <ul className={`${styles.pagination} pagination pagination-md`}>
                        <li className={"page-item" + (currentPage === 1 ? " disabled" : "")}
                            onClick={(e) => goToPage(e, currentPage - 1)}>
                            <a className={`${styles.pageLink} page-link`} href="#" aria-label="Previous">
                                <FontAwesomeIcon size={"xs"} icon={icons.faChevronLeft} aria-hidden="true"/>
                            </a>
                        </li>
                        {renderPageNumbers().map((page, index) => (
                            <li key={index} className={"page-item" + (page === currentPage ? " active" : "")}
                                onClick={(e) => typeof page === 'number' && goToPage(e, page)}>
                                <a className={`${styles.pageLink} page-link`} href="#">{page}</a>
                            </li>
                        ))}
                        <li className={"page-item" + (currentPage === totalPages ? " disabled" : "")}
                            onClick={(e) => goToPage(e, currentPage + 1)}>
                            <a className={`${styles.pageLink} page-link`} href="#" aria-label="Next">
                                <FontAwesomeIcon size={"xs"} icon={icons.faChevronRight} aria-hidden="true"/>
                            </a>
                        </li>
                    </ul>
                </nav>}
            </div>
    );
}

export interface PagerProps {
    defaultPage?: number;
    totalItems: number;
    pageSize?: number;
    onPageChange?: (page: number) => void;
}
